




import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  mounted() {
    window.location.href =
      'https://8.u.mgd5.com/c/wnlw/z3vb/index.html?t=0&custom=&crid=&s=1&prev=liy6388hrh72pmfxpyrcnjlokqwdpykxbneddxm3&time=1688122281423&from=singlemessage';
  }
}
